import request from '@/util/request';
import qs from 'qs';


export const getDetail = (params, options) =>
request.get('/api/v4ward/park/settings/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
request.post('/api/v4ward/park/settings/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/park/settings/submit', params,options);

export const update = (params, options) =>
request.post('/api/v4ward/park/settings/update', params,options);

export const sync = (params, options) =>
  request.post('/api/v4ward/park/settings/sync', params,options);
